import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Modal, ModalHeader, ModalBody } from 'triider-components';
import { Button } from 'components/Button';
import { colors } from '../../styles/stylesheets';

import WelcomeVideoGuarida from './WelcomeVideoGuarida';

export const ModalCustom = styled.div`
   .triider-modal-wrapper {
    flex: initial initial;
    padding: 35px;
    max-height: 495px;
    max-width: 640px;
   }
`;
export const Banner = styled.div`
  background: ${colors.greyLighter};
  border: 1px solid ${colors.alto3};
  border-radius: 8px;
  padding: 20px;
  display: flex;
`;
export const BannerLeft = styled.div`
  flex: 1;
`;
export const Title = styled.h3`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.primary};
`;
export const Description = styled.p`
  font-size: 14px;
  line-height: 24px;
`;
export const ButtonCustom = styled(Button)`
  margin-left: 15px;
  font-size: 12px;
  float: right;
`;

function ModalWelcomeVideo() {
  const { partner } = useParams();

  const [showModalWelcomeVideo, setShowModalWelcomeVideo] = useState(false);
  return partner && partner.includes('guarida') && (
    <ModalCustom>
      <Banner>
        <BannerLeft>
          <Title>Entenda como funciona a parceria</Title>
          <Description>
            Veja um vídeo explicativo e entenda mais como funciona a parceria do
            Triider com a sua imobiliária
          </Description>
        </BannerLeft>
        <ButtonCustom onClick={() => setShowModalWelcomeVideo(true)}>Ver vídeo</ButtonCustom>
      </Banner>
      <Modal
        theme="newParter"
        open={showModalWelcomeVideo}
        close={() => setShowModalWelcomeVideo(false)}
      >
        <ModalHeader>
          Veja como funciona a parceria Guarida & Triider
        </ModalHeader>
        <ModalBody>
          <WelcomeVideoGuarida />
        </ModalBody>
      </Modal>
    </ModalCustom>
  );
}

export default ModalWelcomeVideo;
